<template>
    <div class="row">
        <snappy-table
                :endpoint="'vessels/' + vesselId + '/documents'"
                :columns="['name','created_at']"
                :template-methods="columnTemplates(timezone)"
                :headings="['Name', 'Created']"
                :handle-row-click="onRowClick"
                record-type="Documents"
        >
        </snappy-table>
        <delete-records type="documents"></delete-records>
    </div>
</template>

<script>
    import SnappyTable from '../../components/SnappyTable';
    import DeleteRecords from "../../components/DeleteRecords";
    import columnTemplates from "../../mixins/tables/columnTemplates";

    export default {
        name: 'documents-table',
        components: {SnappyTable, DeleteRecords},
        mixins: [columnTemplates],
        methods: {
            onRowClick(event) {
                window.location.href = 'edit/?sk_token=' + this.documentToken(event.row.id);
            },
            documentToken: function(documentId) {
                return btoa('document_id=' + documentId);
            }
        },
        data() {
            return {

            };
        },
        props: {
            vesselId: {
                type: Number,
                required: true
            },
            timezone: {
                type: String,
                required: true
            }
        }
    }
</script>